export const ROOT = "/admin/claim";
